module.exports = __webpack_public_path__ + "static/media/comprar-imovel-anage.f010bcc0.svg";